/*eslint no-unused-vars: ["error", { "args": "none" }]*/
import axios from 'axios';

export const state = {
    all: [],
}

export const getters = {
    getAll: (state) => state.all,
}

export const actions = {
    async fetchAll({ commit }) {
        const response = await axios.get(`/shops/all`);
        commit('SET_ALL', response.data);
    },
    async fetchProductAttributes({ commit }, id) {
        const response = await axios.get(`/commercial/shop/product/${id}/attributes`);
        return response.data
    },

}

export const mutations = {
    SET_ALL: (state, result) => state.all = result,
}